import { render, staticRenderFns } from "./newTemplateTest.vue?vue&type=template&id=b425023a&scoped=true"
import script from "./newTemplateTest.vue?vue&type=script&lang=js"
export * from "./newTemplateTest.vue?vue&type=script&lang=js"
import style0 from "./newTemplateTest.vue?vue&type=style&index=0&id=b425023a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b425023a",
  null
  
)

export default component.exports